import { Component, Element, h, Host, Prop } from '@stencil/core';
import { Directions, DIRECTIONS } from '../../models/positions.types';
import { PROGRESS_TRACKER_APPEARANCES, ProgressTrackerAppearance } from './models/progress-tracker.types';

@Component({
  tag: 'wink-progress-tracker',
  styleUrl: 'styles/progress-tracker.default.scss',
  scoped: true,
})
export class ProgressTracker {
  @Element() host!: HTMLWinkProgressTrackerElement;

  @Prop() appearance: ProgressTrackerAppearance = PROGRESS_TRACKER_APPEARANCES.default;
  @Prop() direction: Directions = DIRECTIONS.vertical;
  @Prop() label?: string;

  render() {
    const steps = Array.from(this.host.querySelectorAll('wink-progress-tracker-step'));
    if (steps.length > 9) {
      console.warn(
        'wink-progress-tracker: Maximum of 9 steps is supported. Additional steps may not be rendered correctly and can lead to unpredictable behavior.'
      );
    }
    return (
      <Host>
        <div class={`progress-tracker--${this.direction}`} role="list" aria-label={this.label || 'Progress tracker'}>
          <slot />
        </div>
      </Host>
    );
  }
}
